<div class="flex-between-center">
    <div class="flex-1 flex-start-center gap-x-6">
        <div class="w-[72px] h-[72px] min-w-[72px] md:min-w-[120px] md:w-30 md:h-30 rounded-full bg-secondaryCard relative">
            <nz-avatar [nzSrc]="agentInfo?.logo_url" class="!w-full !h-full leading-[72px] md:!leading-[120px] !bg-secondaryCard"></nz-avatar>
        </div>

        <div class="space-y-2">
            <div class="flex-start-center gap-x-2">
                <div class="text-base md:text-xl font-semibold">{{agentInfo?.name || (pageType === 'myWatchlist' ? 'My Watchlist': 'Unnamed')}}</div>
                <div *ngIf="agentInfo?.wallet_address" class="text-sm max-md:hidden text-sub-text">By {{commonService.getAddrName(agentInfo) | address}}</div>

                <button *ngIf="isMyWatchlist" nz-button class="icon-btn !border !border-black !bg-white" nzSize="small" (click)="showEditAgentInfoModal()">
                    <span nz-icon nzType="antd:v2-edit" class="text-base"></span>
                </button>

                <button
                    nz-button
                    nzType="primary"
                    nzSize="small"
                    class="share-btn"
                    (click)="showShareModal()"
                    [disabled]="!hasWatchlistWallets && pageType === 'myWatchlist'"
                >
                    <span nz-icon nzType="antd:v2-share-colorful" class="text-sm"></span>
                    <span class="colorful-text text-sm font-medium">Share</span>
                </button>
            </div>

            <div class="text-sm text-sub-text max-md:hidden">
                <span> {{agentInfo?.introduction || (pageType === 'myWatchlist' ? 'My Watchlist Introduction' :'')}} </span>
            </div>

            <a
                *ngIf="agentInfo?.twitter_username"
                [href]="'https://x.com/' + agentInfo?.twitter_username"
                target="_blank"
                nz-button
                class="icon-btn"
                nzSize="small"
            >
                <span nz-icon nzType="antd:x" class="text-base"></span>
            </a>

            <a
                *ngIf="!agentInfo?.twitter_username && pageType === 'myWatchlist'"
                nz-button
                class="icon-btn !border !border-black !bg-white"
                nzSize="small"
                [routerLink]="['/','my-profile','edit']"
            >
                <span nz-icon nzType="antd:x" class="text-base"></span>
            </a>
        </div>
    </div>

    <!-- Subscribe -->
    <div
        *ngIf="isMyWatchlist"
        class="p-4 h-12 flex-center-center rounded-xl border-[2px] border-line gap-x-1.5 max-md:hidden"
        [nz-tooltip]="peopleCanSubscribeTooltip"
        [ngClass]="{'bg-secondaryCard opacity-50': openToSubscribeDisabled}"
    >
        <nz-switch
            nzSize="small"
            [(ngModel)]="subscribable"
            [disabled]="openToSubscribeDisabled"
            (click)="$event.stopPropagation()"
            (ngModelChange)="changePeopleCanSubscribe()"
        ></nz-switch>
        <span class="text-sm font-medium">People can subscribe</span>
    </div>

    <!-- Other -->
    <ng-container *ngIf="isOther">
        <button
            *ngIf="!agentInfo?.is_subscribed"
            nz-button
            class="max-md:hidden"
            nz-dropdown
            [nzDropdownMenu]="subscribeMenu"
            [nzTrigger]="'click'"
            [nzLoading]="submittingSubscribe"
        >
            Subscribe (100 Points)
            <span nz-icon nzType="caret-down" nzTheme="outline"></span>
        </button>

        <button
            *ngIf="agentInfo?.is_subscribed"
            nz-button
            class="max-md:hidden !border-black !border-opacity-10"
            nz-tooltip="Your TG Agent is now tracking Smart Money transactions from this watchlist."
            (click)="unsubscribeModalVisible = true"
        >
            Unsubscribe
        </button>
    </ng-container>
</div>

<div class="text-sm mt-4 text-sub-text md:hidden">{{agentInfo?.introduction || (pageType === 'myWatchlist' ? 'My Watchlist Introduction' :'')}}</div>

<button
    *ngIf="isOther"
    nz-button
    class="!border-[2px] !border-line !rounded-xl gap-x-1.5 md:hidden !h-12 mt-4 w-full"
    nz-dropdown
    [nzDropdownMenu]="subscribeMenu"
    [nzTrigger]="'click'"
    [nzLoading]="submittingSubscribe"
>
    <span class="text-sm font-medium">Subscribe (100 Points)</span>
    <span nz-icon nzType="caret-down" nzTheme="outline"></span>
</button>

<!-- PC Metrics -->
<div class="grid grid-cols-[2fr_2fr_1fr_1fr] gap-y-6 mt-4 md:mt-10 w-full max-md:hidden px-8 py-6 border border-opacity-10 border-black rounded-lg">
    <div *ngFor="let metricName of metrics" class="fit-content">
        <div class="text-xs text-sub-text mb-2">{{metricName}}</div>
        <div class="text-sm font-medium">
            <div class="flex-start-center gap-x-1" *ngIf="metricName === 'Wallets Count'">
                <img src="/assets/imgs/chains/eth-blue.png" class="w-3 h-3 md:w-4 md:h-4" alt="" />
                <span>{{agentInfo?.address_count_eth || 0}}</span>

                <img src="/assets/imgs/chains/solana.png" class="w-3 h-3 md:w-4 md:h-4 ml-3" alt="" />
                <span>{{agentInfo?.address_count_sol || 0}}</span>
            </div>
            <ng-container *ngIf="metricName === '7D Pnl'">
                <div *ngIf="agentInfo">
                    <div class="value mb-0.5" [ngClass]="{'text-success': agentInfo?.stats.pnl_7d > 0, 'text-error': agentInfo?.stats.pnl_7d < 0}">
                        {{formatTinyNumber(agentInfo?.stats.pnl_7d || 0)}}
                        <span>
                            ({{agentInfo?.stats.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats.pnl_7d / agentInfo?.stats.buy_usd_7d || 0)|percent:'1.0-2'}})
                        </span>
                    </div>

                    <div
                        class="flex-start-center font-normal flex-wrap gap-0.5 text-xs text-[#c8c8c8]"
                        *ngIf="agentInfo?.stats_base || agentInfo?.stats_bsc || agentInfo?.stats_sol"
                    >
                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_base">
                            <img src="/assets/imgs/chains/base.png" class="w-2.5 h-2.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_base.pnl_7d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_base.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats_base.pnl_7d / agentInfo?.stats_base.buy_usd_7d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>

                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_bsc">
                            <img src="/assets/imgs/chains/bnb.png" class="w-2.5 h-2.5 ml-0.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_bsc.pnl_7d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_bsc.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats_bsc.pnl_7d / agentInfo?.stats_bsc.buy_usd_7d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>

                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_sol">
                            <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5 ml-0.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_sol.pnl_7d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_sol.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats_sol.pnl_7d / agentInfo?.stats_sol.buy_usd_7d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="metricName === '30D Pnl'">
                <div *ngIf="agentInfo">
                    <div
                        *ngIf="agentInfo"
                        class="value mb-0.5"
                        [ngClass]="{'text-success': agentInfo?.stats.pnl_30d > 0, 'text-error': agentInfo?.stats.pnl_30d < 0}"
                    >
                        {{formatTinyNumber(agentInfo?.stats.pnl_30d || 0)}}
                        <span>
                            ({{agentInfo?.stats.pnl_30d > 0 ? '+' : ''}}{{(agentInfo?.stats.pnl_30d / agentInfo?.stats.buy_usd_30d || 0)|percent:'1.0-2'}})
                        </span>
                    </div>

                    <div
                        class="flex-start-center flex-wrap gap-0.5 font-normal text-xs text-[#c8c8c8]"
                        *ngIf="agentInfo?.stats_base || agentInfo?.stats_bsc || agentInfo?.stats_sol"
                    >
                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_base">
                            <img src="/assets/imgs/chains/base.png" class="w-2.5 h-2.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_base.pnl_30d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_base.pnl_30d > 0 ? '+' : ''}}{{(agentInfo?.stats_base.pnl_30d / agentInfo?.stats_base.buy_usd_30d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>

                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_bsc">
                            <img src="/assets/imgs/chains/bnb.png" class="w-2.5 h-2.5 ml-0.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_bsc.pnl_30d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_bsc.pnl_30d > 0 ? '+' : ''}}{{(agentInfo?.stats_bsc.pnl_30d / agentInfo?.stats_bsc.buy_usd_30d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>

                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_sol">
                            <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5 ml-0.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_sol.pnl_30d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_sol.pnl_30d > 0 ? '+' : ''}}{{(agentInfo?.stats_sol.pnl_30d / agentInfo?.stats_sol.buy_usd_30d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="metricName === 'Win Rate'">
                <div *ngIf="agentInfo">
                    <div class="mb-0.5">{{(agentInfo?.stats.win_rate || 0) | percent:'1.0-2'}}</div>
                    <div
                        class="flex-start-center flex-wrap gap-0.5 font-normal text-xs text-[#c8c8c8]"
                        *ngIf="agentInfo?.stats_base || agentInfo?.stats_bsc || agentInfo?.stats_sol"
                    >
                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_base">
                            <img src="/assets/imgs/chains/base.png" class="w-2.5 h-2.5" alt="" />
                            <span> {{(agentInfo?.stats_base.win_rate || 0) | percent:'1.0-2'}}</span>
                        </div>

                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_bsc">
                            <img src="/assets/imgs/chains/bnb.png" class="w-2.5 h-2.5 ml-0.5" alt="" />
                            <span> {{(agentInfo?.stats_bsc.win_rate || 0) | percent:'1.0-2'}}</span>
                        </div>

                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_sol">
                            <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5 ml-0.5" alt="" />
                            <span> {{(agentInfo?.stats_sol.win_rate || 0) | percent:'1.0-2'}}</span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="metricName === 'Daily Hunted MEMEs'">
                <div *ngIf="agentInfo">
                    <div class="mb-0.5">{{agentInfo?.stats.meme_hunted_1d || 0}}</div>

                    <div
                        class="flex-start-center flex-wrap gap-0.5 font-normal text-xs text-[#c8c8c8]"
                        *ngIf="agentInfo.stats_base || agentInfo.stats_bsc || agentInfo.stats_sol"
                    >
                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_base">
                            <img src="/assets/imgs/chains/base.png" class="w-2.5 h-2.5" alt="" />
                            <div>{{agentInfo?.stats_base.meme_hunted_1d || 0}}</div>
                        </div>

                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_bsc">
                            <img src="/assets/imgs/chains/bnb.png" class="w-2.5 h-2.5 ml-0.5" alt="" />
                            <div>{{agentInfo?.stats_bsc.meme_hunted_1d || 0}}</div>
                        </div>

                        <div class="flex-start-center gap-x-0.5 whitespace-nowrap" *ngIf="agentInfo?.stats_sol">
                            <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5 ml-0.5" alt="" />
                            <div>{{agentInfo?.stats_sol.meme_hunted_1d || 0}}</div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="metricName === 'Daily Alerts'">{{agentInfo?.stats.alert_1d || 0}}</ng-container>
            <ng-container *ngIf="metricName === 'Subscribers'">{{agentInfo?.subscriber_count || 0}}</ng-container>
            <div *ngIf="metricName === 'Subscription Earning'" class="flex-start-center">
                <img src="/assets/imgs/icon/sun-v2.png" alt="" class="w-3 h-3 p-0.5 rounded-full bg-black mr-1" />
                <span class="text-sm font-medium">{{(agentInfo?.total_points_earned || 0)| kmb2:2}}</span>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Metrics -->
<div class="grid grid-cols-2 gap-x-6 gap-y-2 mt-4 w-full md:hidden p-4 border border-line rounded-lg whitespace-nowrap overflow-x-auto min-w-fit">
    <div *ngFor="let metricName of metrics" class="text-sm">
        <div class="text-sub-text">{{metricName}}</div>
        <div class="font-medium">
            <div *ngIf="metricName === 'Wallets Count'" class="flex-start-center gap-x-1">
                <img src="/assets/imgs/chains/eth-blue.png" class="w-2.5 h-2.5" alt="" />
                <span>{{agentInfo?.address_count || 0}}</span>

                <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5 ml-2" alt="" />
                <span>{{agentInfo?.address_count_sol || 0}}</span>
            </div>
            <ng-container *ngIf="metricName === '7D Pnl'">
                <div *ngIf="agentInfo">
                    <div class="value" [ngClass]="{'text-success': agentInfo?.stats.pnl_7d > 0, 'text-error': agentInfo?.stats.pnl_7d < 0}">
                        {{formatTinyNumber(agentInfo?.stats.pnl_7d || 0)}}
                        <span>
                            ({{agentInfo?.stats.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats.pnl_7d / agentInfo?.stats.buy_usd_7d || 0)|percent:'1.0-2'}})
                        </span>
                    </div>

                    <div
                        class="flex-start-center flex-wrap gap-0.5 font-normal text-2xs text-[#c8c8c8]"
                        *ngIf="agentInfo?.stats_base || agentInfo?.stats_bsc || agentInfo?.stats_sol"
                    >
                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_base">
                            <img src="/assets/imgs/chains/base.png" class="w-2.5 h-2.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_base.pnl_7d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_base.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats_base.pnl_7d / agentInfo?.stats_base.buy_usd_7d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>

                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_bsc">
                            <img src="/assets/imgs/chains/bnb.png" class="w-2.5 h-2.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_bsc.pnl_7d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_bsc.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats_bsc.pnl_7d / agentInfo?.stats_bsc.buy_usd_7d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>

                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_sol">
                            <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_sol.pnl_7d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_sol.pnl_7d > 0 ? '+' : ''}}{{(agentInfo?.stats_sol.pnl_7d / agentInfo?.stats_sol.buy_usd_7d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="metricName === '30D Pnl'">
                <div *ngIf="agentInfo">
                    <div *ngIf="agentInfo" class="value" [ngClass]="{'text-success': agentInfo?.stats.pnl_30d > 0, 'text-error': agentInfo?.stats.pnl_30d < 0}">
                        {{formatTinyNumber(agentInfo?.stats.pnl_30d || 0)}}
                        <span>
                            ({{agentInfo?.stats.pnl_30d > 0 ? '+' : ''}}{{(agentInfo?.stats.pnl_30d / agentInfo?.stats.buy_usd_30d || 0)|percent:'1.0-2'}})
                        </span>
                    </div>

                    <div
                        class="flex-start-center flex-wrap gap-0.5 font-normal text-2xs text-[#c8c8c8]"
                        *ngIf="agentInfo?.stats_base || agentInfo?.stats_bsc || agentInfo?.stats_sol"
                    >
                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_base">
                            <img src="/assets/imgs/chains/base.png" class="w-2.5 h-2.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_base.pnl_30d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_base.pnl_30d > 0 ? '+' : ''}}{{(agentInfo?.stats_base.pnl_30d / agentInfo?.stats_base.buy_usd_30d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>

                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_bsc">
                            <img src="/assets/imgs/chains/bnb.png" class="w-2.5 h-2.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_bsc.pnl_30d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_bsc.pnl_30d > 0 ? '+' : ''}}{{(agentInfo?.stats_bsc.pnl_30d / agentInfo?.stats_bsc.buy_usd_30d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>

                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_sol">
                            <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5" alt="" />
                            <span>
                                {{formatTinyNumber(agentInfo?.stats_sol.pnl_30d || 0)}}
                                <span>
                                    ({{agentInfo?.stats_sol.pnl_30d > 0 ? '+' : ''}}{{(agentInfo?.stats_sol.pnl_30d / agentInfo?.stats_sol.buy_usd_30d ||
                                    0)|percent:'1.0-2'}})
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="metricName === 'Win Rate'">
                <div *ngIf="agentInfo">
                    <div>{{(agentInfo?.stats.win_rate || 0) | percent:'1.0-2'}}</div>
                    <div
                        class="flex-start-center gap-x-0.5 font-normal text-xs text-[#c8c8c8]"
                        *ngIf="agentInfo?.stats_base || agentInfo?.stats_bsc || agentInfo?.stats_sol"
                    >
                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_base">
                            <img src="/assets/imgs/chains/base.png" class="w-2.5 h-2.5" alt="" />
                            <span> {{(agentInfo?.stats_base.win_rate || 0) | percent:'1.0-2'}}</span>
                        </div>

                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_bsc">
                            <img src="/assets/imgs/chains/bnb.png" class="w-2.5 h-2.5" alt="" />
                            <span> {{(agentInfo?.stats_bsc.win_rate || 0) | percent:'1.0-2'}}</span>
                        </div>

                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_sol">
                            <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5" alt="" />
                            <span> {{(agentInfo?.stats_sol.win_rate || 0) | percent:'1.0-2'}}</span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="metricName === 'Daily Hunted MEMEs'">
                <div *ngIf="agentInfo">
                    <div>{{agentInfo?.stats.meme_hunted_1d || 0}}</div>

                    <div
                        class="flex-start-center gap-x-0.5 font-normal text-2xs text-[#c8c8c8]"
                        *ngIf="agentInfo.stats_base || agentInfo.stats_bsc || agentInfo.stats_sol"
                    >
                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_base">
                            <img src="/assets/imgs/chains/base.png" class="w-2.5 h-2.5" alt="" />
                            <div>{{agentInfo?.stats_base.meme_hunted_1d || 0}}</div>
                        </div>

                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_bsc">
                            <img src="/assets/imgs/chains/bnb.png" class="w-2.5 h-2.5" alt="" />
                            <div>{{agentInfo?.stats_bsc.meme_hunted_1d || 0}}</div>
                        </div>

                        <div class="flex-start-center gap-x-0.5" *ngIf="agentInfo?.stats_sol">
                            <img src="/assets/imgs/chains/solana.png" class="w-2.5 h-2.5" alt="" />
                            <div>{{agentInfo?.stats_sol.meme_hunted_1d || 0}}</div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="metricName === 'Daily Alerts'">{{agentInfo?.stats.alert_1d || 0}}</ng-container>
            <ng-container *ngIf="metricName === 'Subscribers'">{{agentInfo?.subscriber_count || 0}}</ng-container>
            <div *ngIf="metricName === 'Subscription Earning'" class="flex-start-center">
                <img src="/assets/imgs/icon/sun-v2.png" alt="" class="w-3 h-3 p-0.5 rounded-full bg-black mr-1" />
                <span class="text-sm font-medium">{{(agentInfo?.total_points_earned || 0)| kmb2:2}}</span>
            </div>
        </div>
    </div>
</div>

<nz-dropdown-menu #subscribeMenu="nzDropdownMenu">
    <ul nz-menu>
        <li nz-menu-item (click)="subscribe()">
            <div class="flex-start-center gap-x-2 text-xs">
                <div class="w-[18px] h-[18px] rounded-full bg-black p-[3px]">
                    <img src="/assets/imgs/icon/sun-v2.png" class="w-full h-full" alt="" />
                </div>

                <span>100 Points</span>
            </div>
        </li>

        <li nz-menu-item>
            <div class="flex-start-center gap-x-2 opacity-50 text-xs">
                <div class="w-[18px] h-[18px] rounded-full bg-black">
                    <img src="/assets/imgs/hemera-black.png" class="w-full h-full" alt="" />
                </div>
                <span>10 $DAY</span>
                <span class="text-sub-text text-2xs px-1 py-0.5 rounded bg-secondaryCard"> Coming soon</span>
            </div>
        </li>

        <li nz-menu-item>
            <div class="flex-start-center gap-x-2 opacity-50 text-xs">
                <div class="w-[18px] h-[18px] rounded-full bg-black p-[3px]">
                    <img src="/assets/imgs/usdt.png" class="w-full h-full" alt="" />
                </div>

                <span>USDT</span>
                <span class="text-sub-text text-2xs px-1 py-0.5 rounded bg-secondaryCard"> Coming soon</span>
            </div>
        </li>

        <li nz-menu-item>
            <div class="flex-start-center gap-x-2 opacity-50 text-xs">
                <div class="w-[18px] h-[18px] rounded-full bg-black p-[3px]">
                    <img src="/assets/imgs/usdc.png" class="w-full h-full" alt="" />
                </div>

                <span>USDC</span>
                <span class="text-sub-text text-2xs px-1 py-0.5 rounded bg-secondaryCard"> Coming soon</span>
            </div>
        </li>
    </ul>
</nz-dropdown-menu>

<nz-modal
    nzTitle="Confirm to unsubscribe from {{agentInfo?.name || 'Unnamed'}}?"
    [(nzVisible)]="unsubscribeModalVisible"
    (nzOnCancel)="unsubscribeModalVisible = false"
    nzCentered
    [nzClosable]="false"
>
    <ng-container *nzModalContent>
        <div class="text-center text-[#999]">Once completed, 1 subscription slot will be freed, and used points won't be refunded.</div>
    </ng-container>

    <ng-container *nzModalFooter>
        <button nz-button nzType="default" (click)="unsubscribeModalVisible = false">Cancel</button>
        <button nz-button nzType="primary" (click)="unsubscribe()" [nzLoading]="submittingSubscribe">Confirm</button>
    </ng-container>
</nz-modal>
